import Vue from 'vue';
import '@babel/polyfill';
import './plugins/axios';
import './plugins/vuetify';
import './plugins/vue-socket';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';

Vue.config.productionTip = false;

// if (!store.state.auth.user) {
// const refresh = localStorage.gmxr; // cookies.get('gm-token');
// if (refresh) {
// token must have expired. Do a refresh here and go for it.
// just go get clean token
// store
//   .dispatch('auth/refresh')
//   .then(response => {
//     console.log('startup refresh concluded with:', response);
//   })
//   .catch(e => console.log('auth/refresh dispatch error', e));
// } else {
//   console.log('We have a user:', store.state.auth.user);
//   console.log('We need to valid the token here to see if it is OK');
//   console.log('If not we can refresh it');
//   console.log(
//     'We must also document when we refreshed the token last and make sure we do it within 24 hours'
//   );
// }

Vue.use(VueAnalytics, {
  id: 'UA-68245-28',
  router,
  autoTracking: {
    exception: true,
    screenview: true
  },
  debug: {
    // enabled: true,
    sendHitTask: true
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
